import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef, useEffect } from "react";
import { styled } from "@material-ui/styles";
import RelationshipArrows from "../RelationshipArrows";
import colors from "../../colors";
import ArrowToMouse from "../ArrowToMouse";
import { useTimeout, useWindowSize } from "react-use";
import SequenceItem from "../SequenceItem";
import classNames from "classnames";
import stringToSequence from "../../string-to-sequence";
import useEventCallback from "use-event-callback";
var Container = styled("div")(function (_ref) {
  var relationshipsOn = _ref.relationshipsOn;
  return {
    lineHeight: 1.5,
    marginTop: relationshipsOn ? 64 : 0,
    display: "flex",
    flexWrap: "wrap"
  };
});
export default function Document(_ref2) {
  var sequence = _ref2.sequence,
      relationships = _ref2.relationships,
      _ref2$onHighlightedCh = _ref2.onHighlightedChanged,
      onHighlightedChanged = _ref2$onHighlightedCh === void 0 ? function () {
    return null;
  } : _ref2$onHighlightedCh,
      _ref2$onCreateEmptyRe = _ref2.onCreateEmptyRelationship,
      onCreateEmptyRelationship = _ref2$onCreateEmptyRe === void 0 ? function () {
    return null;
  } : _ref2$onCreateEmptyRe,
      _ref2$onSequenceChang = _ref2.onSequenceChange,
      onSequenceChange = _ref2$onSequenceChang === void 0 ? function () {
    return null;
  } : _ref2$onSequenceChang,
      _ref2$onRelationships = _ref2.onRelationshipsChange,
      onRelationshipsChange = _ref2$onRelationships === void 0 ? function () {
    return null;
  } : _ref2$onRelationships,
      _ref2$nothingHighligh = _ref2.nothingHighlighted,
      nothingHighlighted = _ref2$nothingHighligh === void 0 ? false : _ref2$nothingHighligh,
      _ref2$createRelations = _ref2.createRelationshipsMode,
      createRelationshipsMode = _ref2$createRelations === void 0 ? false : _ref2$createRelations,
      _ref2$colorLabelMap = _ref2.colorLabelMap,
      colorLabelMap = _ref2$colorLabelMap === void 0 ? {} : _ref2$colorLabelMap;
  var sequenceItemPositionsRef = useRef({});

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      mouseDown = _useState2[0],
      changeMouseDown = _useState2[1];

  var _useTimeout = useTimeout(30),
      _useTimeout2 = _slicedToArray(_useTimeout, 3),
      timeoutCalled = _useTimeout2[0],
      cancelTimeout = _useTimeout2[1],
      resetTimeout = _useTimeout2[2]; // Force rerender after mounting


  var windowSize = useWindowSize();
  useEffect(function () {
    resetTimeout();
  }, [windowSize]);

  var _useState3 = useState([null, null]),
      _useState4 = _slicedToArray(_useState3, 2),
      _useState4$ = _slicedToArray(_useState4[0], 2),
      firstSelected = _useState4$[0],
      lastSelected = _useState4$[1],
      changeHighlightedRangeState = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      firstSequenceItem = _useState6[0],
      setFirstSequenceItem = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      secondSequenceItem = _useState8[0],
      setSecondSequenceItem = _useState8[1];

  useEffect(function () {
    setFirstSequenceItem(null);
    setSecondSequenceItem(null);
    changeHighlightedRangeState([null, null]);
    changeMouseDown(false);
  }, [createRelationshipsMode]);

  var changeHighlightedRange = function changeHighlightedRange(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        first = _ref4[0],
        last = _ref4[1];

    if (createRelationshipsMode) return;
    changeHighlightedRangeState([first, last]);
    var highlightedItems = [];

    for (var i = Math.min(first, last); i <= Math.max(first, last); i++) {
      highlightedItems.push(i);
    }

    onHighlightedChanged(highlightedItems);
  };

  var highlightedItems = [];

  if (!nothingHighlighted && firstSelected !== null && lastSelected !== null) {
    for (var i = Math.min(firstSelected, lastSelected); i <= Math.max(firstSelected, lastSelected); i++) {
      highlightedItems.push(i);
    }
  }

  var onRemoveLabel = useEventCallback(function (sequenceItemIndex) {
    onSequenceChange(sequence.flatMap(function (s, i) {
      return i !== sequenceItemIndex ? s : stringToSequence(s.text);
    }).filter(function (s) {
      return s.text.length > 0;
    }));
  });
  return /*#__PURE__*/React.createElement(Container, {
    relationshipsOn: Boolean(relationships),
    onMouseDown: function onMouseDown() {
      return changeMouseDown(true);
    },
    onMouseUp: function onMouseUp() {
      if (createRelationshipsMode && firstSequenceItem) {
        setFirstSequenceItem(null);

        if (secondSequenceItem) {
          setSecondSequenceItem(null);
        }
      }

      changeMouseDown(false);
    }
  }, sequence.map(function (seq, i) {
    return /*#__PURE__*/React.createElement(SequenceItem, Object.assign({}, seq, {
      sequenceItemIndex: i,
      sequenceItemPositionsRef: sequenceItemPositionsRef,
      relationshipsOn: Boolean(relationships),
      createRelationshipsMode: createRelationshipsMode,
      onChangeFirstSequenceItem: setFirstSequenceItem,
      onChangeSecondSequenceItem: setSecondSequenceItem,
      onCreateEmptyRelationship: onCreateEmptyRelationship,
      onChangeHighlightedRange: changeHighlightedRange,
      firstSequenceItem: firstSequenceItem,
      secondSequenceItem: secondSequenceItem,
      mouseDown: mouseDown,
      firstSelected: firstSelected,
      lastSelected: lastSelected,
      isHighlighted: highlightedItems.includes(i),
      onRemoveLabel: onRemoveLabel,
      color: seq.color || colorLabelMap[seq.label],
      key: i
    }));
  }), firstSequenceItem && !secondSequenceItem && /*#__PURE__*/React.createElement(ArrowToMouse, {
    startAt: ((sequenceItemPositionsRef.current || {})[firstSequenceItem] || {}).offset
  }), relationships && /*#__PURE__*/React.createElement(RelationshipArrows, {
    onClickArrow: function onClickArrow(_ref5) {
      var label = _ref5.label,
          from = _ref5.from,
          to = _ref5.to;
      onRelationshipsChange(relationships.filter(function (r) {
        return !(r.from === from && r.to === to && r.label === label);
      }));
    },
    positions: sequenceItemPositionsRef.current,
    arrows: relationships.map(function (a, i) {
      return _objectSpread({}, a, {
        color: a.color || colors[i % colors.length]
      });
    })
  }));
}